import { Link } from "react-router-dom";
import { getUser } from "helpers/localStorage";
import { getDefaultRoute } from "config/permissions";

const Unauthorized = () => {
  const user = getUser();
  const homeRoute = getDefaultRoute(user?.type);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center p-5 text-center">
      <h2>Access Denied</h2>
      <p className="text-muted mb-4">
        You do not have permission to access this page.
      </p>
      <Link to={homeRoute} className="btn btn-primary">
        Go to Dashboard
      </Link>
    </div>
  );
};

export default Unauthorized;
